import { IncomingMessage } from 'http';
import Cookies from 'js-cookie';
import { isProd } from '../constants/app';

// Constants for cookie names
export const EXIST_COOKIES = {
    AUTHTOKEN: 'auth_token',
    API_KEY: 'api_key',
    USER_ID: 'user_id',
};

// cookie.config.ts
export const SERVER_COOKIE_DEFAULTS = {
    httpOnly: false,
    secure: isProd,
    sameSite: 'lax' as const,
    path: '/',
};

export const CLIENT_COOKIE_DEFAULTS = {
    httpOnly: false,
    secure: isProd,
    sameSite: 'lax' as const,
    path: '/',
};

export function getServerCookieOptions(isStayLogin?: boolean) {
    const opts: any = { ...SERVER_COOKIE_DEFAULTS };

    if (isStayLogin) {
        // maxAge is in seconds for NextResponse.cookies.set()
        opts.maxAge = 60 * 60 * 24 * 7; // 7 days
    }
    return opts;
}

export const setCookie = (name: string, value: any, days: number | null = 7) => {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    const opts: any = { ...CLIENT_COOKIE_DEFAULTS };
    if (days) {
        opts.expires = days;
    }
    Cookies.set(name, stringValue, opts);
};

export const getCookie = (name: string) => {
    return Cookies.get(name) || '';
};

export const removeCookie = (name?: string) => {
    const options = { path: '/' };
    if (name) {
        Cookies.remove(name, options);
    } else {
        // Remove all cookies in our list
        Object.keys(EXIST_COOKIES).forEach((cookieName) => {
            Cookies.remove(cookieName, options);
        });
    }
};

// SERVER-SIDE FUNCTIONS
// Use these in getServerSideProps, API routes, etc.

export const getServerCookie = (req: IncomingMessage & { cookies?: Partial<{ [key: string]: string }> }) => {
    // For API routes, req.cookies is available directly
    // For getServerSideProps, Next.js adds cookies to req
    return (name: string) => {
        const cookies = req.cookies || {};
        return cookies[name] || 'undefined';
    };
};

export const setEncodetext = (text: string): string => {
    if (!text) return '';
    return (
        text
            .replaceAll(/\//g, '|')
            .replaceAll('&', '_and_')
            // .replace(/-/g, "_dash_") // Replace original hyphens first
            .replaceAll(' ', '-')
    );
};
